import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { costBreakdownV2WidgetCostsSelector } from "./costBreakdownV2WidgetCostsSelector";

export const costBreakdownV2WidgetTotalCostSelector = createDraftSafeSelector(
  [costBreakdownV2WidgetCostsSelector],
  (costs) => {
    return costs?.total;
  },
);
